import { render, staticRenderFns } from "./WeedCard.vue?vue&type=template&id=7a66cda9"
import script from "./WeedCard.vue?vue&type=script&lang=js"
export * from "./WeedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports